module.exports = __webpack_public_path__ + "img/ex4.608184aa.jpg";